import script from "./SellerPriceOffer.vue?vue&type=script&setup=true&lang=js"
export * from "./SellerPriceOffer.vue?vue&type=script&setup=true&lang=js"

import "./SellerPriceOffer.vue?vue&type=style&index=0&id=fdce99c6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdce99c6"]])

export default __exports__